import { type BannerContext, type Device } from '../model';

import { type ExternalResponse, type Response } from './get-banners-ads';

interface AdapterProps {
  context: BannerContext;
  device: Device;
  externalResponse: ExternalResponse;
}

export default function adapter(props: Readonly<AdapterProps>) {
  const { context, device, externalResponse } = props;

  const response: Response = {
    data:
      externalResponse[
        `${device}_${context.name}_${context.position}_banner`
      ] || [],
  };

  return response;
}
